module.exports = __webpack_public_path__ + "img/8.c4b01567.jpg";